import React from "react";

const Info = () => {
  return (
    <div className="about__info grid">
      <div className="about__box">
        <i class="bx bx-award"></i>
        <h3 className="about__title">Experience</h3>
        <span className="about__subtitle">5+ Years Building</span>
      </div>

      <div className="about__box">
        <i class="bx bx-briefcase"></i>
        <h3 className="about__title">Shipped</h3>
        <span className="about__subtitle">20+ Products</span>
      </div>

      <div className="about__box">
        <i class="bx bx-support"></i>
        <h3 className="about__title">Focus</h3>
        <span className="about__subtitle">AI · SaaS · Real-time</span>
      </div>
    </div>
  );
};

export default Info;
